export default __webpack_public_path__ + "static/media/recipe-app-screeshot1.8dbc1693.jpg";